export default function getOnboardingData({ state }) {
  return state.get(['onboarding', 'formData']);
}
